module.exports = __webpack_public_path__ + "static/media/TableAbrasion_After.c2b9cc81.jpg";